import { Button, Modal, ModalType, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';

interface TwoFactorConfirmationModalType extends ModalType {
	recoveryCodes: Array<string>;
}

function TwoFactorConfirmationModal(props: TwoFactorConfirmationModalType) {
	const { t } = useTranslation();

	return (
		<Modal
			title={t(`settings.twoFactorAuth.authTypes.1.confirmation.title`)}
			isOpen={props.isOpen}
			closeCallback={props.closeCallback}
		>
			<div className='recovery-codes'>
				<p>{t(`settings.twoFactorAuth.authTypes.1.confirmation.description`)}</p>
				<p>{t(`settings.twoFactorAuth.authTypes.1.confirmation.warning`)}</p>
				<div className='recovery-codes'>
					{props.recoveryCodes.map((code) => (
						<span>{code}</span>
					))}
				</div>
			</div>
			<Button title='Copy' />
		</Modal>
	);
}

export { TwoFactorConfirmationModal };
